import React, { useEffect, useRef, useState } from "react";
import HorseLeasingSection from "./services/shared/components/HorseLeasingSection";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import NetaqInput from "../components/NetaqInput";
import Select from "react-select";
import ActionButton from "../components/ActionButton";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import {
    FetchCreateOrEditHorseImportthunk,
    FetchGetServiceDefinitionByIdthunk,
    FetchGetServicesRequestByIdthunk,
    FetchGetShippingAgentsthunk,
    FetchHorsesExportTemporarythunk,
} from "../Redux/ServicesRequests/ServicesRequestsAction";
import {
    resetGetServicesRequestByIdData,
    resetToasterMessageServicesRequests,
} from "../Redux/ServicesRequests/ServicesRequestsSlice";
import { FetchSubOwnerProfilesByIdthunk } from "../Redux/ShowEntry/ShowEntryAction";
import dayjs from "dayjs";
import EahsForm from "../components/EahsForm";
import { FetchStudBookCountriesthunk } from "../Redux/StudBook/StudBookAction";
import SimpleFileUpload from "../components/SimpleFileUpload";
import { base64ToBlob } from "../helper/base64ToBlob";
import { FetchHorseColorsthunk } from "../Redux/LookUp/LookUpAction";
import { eFormButtonsContainer, eformCheckBox, eformInput, eformTerms, serviceRequestHeadContainer, serviceRequestTitle, userDropDown } from "../common/cssclasses";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import PillBtn from "../components/PillBtn";
import DraftBtn from "../components/servicesButtons/DraftBtn";
import ApproveAndPayLaterBtn from "../components/servicesButtons/ApproveAndPayLaterBtn";
import ApproveAndPayBtn from "../components/servicesButtons/ApproveAndPayBtn";
import SubmitServiceBtn from "../components/servicesButtons/SubmitServiceBtn";
import _ from "lodash";
import axiosInstance from "../axios/axios";
import { formatDate } from "../helper/formatDate";

export default function ImportHorse() {
    //env
    const UMBRACOURL = process.env.REACT_APP_UMBRACO;
    // const UMBRACOURL = process.env.REACT_APP_Local_UMBRACO;
    const BaseURL = process.env.REACT_APP_BASE_URL;

    //selector
    const { studBookCountries, currentLanguage } = useSelector((state) => state.studBookSlice);

    const { horseColorsData } = useSelector(
        (state) => state.lookUpSlice
    );

    const {
        toasterMessageServicesRequests,
        servicesRequestsLoading,
        getServicesRequestByIdData,
        getServiceDefinitionByIdData,
        importHorseData,
        getShippingAgentsData,
        horsesExportTemporaryData,
    } = useSelector((state) => state.servicesRequestsSlice);

    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const subOwnerProfilesByIdData = userProfile?.subAccounts ?? [];

    const dispatch = useDispatch();

    const { translate } = useTranslate();

    const navigate = useNavigate();

    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);

    const serviceId = searchParams.has("serviceId")
        ? searchParams.get("serviceId")
        : null;

    const id = searchParams.has("id") ? searchParams.get("id") : null;

    const action = searchParams.has("action") ? searchParams.get("action") : null;
    const ownerId = searchParams.has("ownerId") ? searchParams.get("ownerId") : null;

    const horseImportType = searchParams.has("horseImportType") ? searchParams.get("horseImportType") : null;

    //state
    const [profile, setProfile] = useState({
        label:
            !!userProfile &&
            userProfile?.ownerRegisterNo +
            " - " +
            userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
        value: localStorage.getItem("EAHSUserID"),
    });

    const [formModel, setFormModel] = useState({
        id: "",
        temporaryHorseImportsId: "",
        eventName: "",
        comment: "",
        referenceNumber: "",
        requestsType: "",
        paymentStatus: "",

        horseImportType: horseImportType,
        importDate: null,
        outDate: null,

        horseType: "UnRegistered",
        horse: "",
        horseDrop: {
            label: translate("web.horse", "Horse"),
            value: null,
        },

        importCountry: "",
        importCountryDrop: {
            label: translate("web.chooseCountry", "Choose Country"),
            value: null,
        },

        uaePlace: "",
        emirateId: "",
        emirateDrop: {
            label: translate("web.chooseEmirate", "Choose Emirate"),
            value: null,
        },
        uaeQuarantine: "",
        uaeQuarantineDrop: {
            label: translate("web.chooseUaeQuarantine", "Choose UAE Quarantine"),
            value: null,
        },
        quarantineId: "",
        quarantineEmirateId: "",
        quarantineName: "",
        isLegacyQuarantine: false,
        importPurpose: "",
        evName: "",

        oldHorsesListCount: 0,
        horses: [],
        horseName: "",
        horseNameAr: "",
        regNo: 0,
        sire: "",
        dam: "",
        microchipNo: "",
        dateFoaled: "",
        color: "",
        colorDrop: {
            label: translate("web.color", "Color"),
            value: null,
        },
        eventType: "Treatment",
        sex: "Stallion",

        registerHorse: horseImportType === "PERMANENT",

        otherOwner: false,

        ownerName: profile?.label,
        email: userProfile?.email,
        mobile: "",
        agentMobile: "",

        shippingAgent: "",
        shippingAgentDrop: {
            label: currentLanguage === "en" ? translate("web.shippingAgent", "Shipping Agent") : "وكالة الشحن",
            value: null,
        },

        shippingAgentNameEn: "",
        shippingAgentNameAr: "",
        shippingAgentMobile: "",
        shippingAgentEmail: "",

        ownerComment: "",

        filePathInvitation: "",
        fileTypeInvitation: "",
        fileNameInvitation: "",
        fileUrlInvitation: "",
        invitationAttachmentFile: null,

        filePathHorsePassport: "",
        fileTypeHorsePassport: "",
        fileNameHorsePassport: "",
        fileUrlHorsePassport: "",
        horsePassportAttachmentFile: null,

        filePathResidencePermit: "",
        fileTypeResidencePermit: "",
        fileNameResidencePermit: "",
        fileUrlResidencePermit: "",
        residencePermitAttachmentFile: null,

        passportNo: "",

        isLeasing: false,
        leaseStartDate: null,
        leaseEndDate: null,
        canParticipateInBeautyChampionships: false,
        canCoverAndRegisterFoals: false,
        canRegisterFoalsForOtherOwners: false,
        canImportAndExport: false
    });

    const [errorImportDate, setErrorImportDate] = useState(false);
    const [errorOutDate, setErrorOutDate] = useState(false);
    const [errorImportCountry, setErrorImportCountry] = useState(false);
    const [errorUaePlace, setErrorUaePlace] = useState(false);
    const [errorEmirate, setErrorEmirate] = useState(false);
    const [errorUaeQuarantine, setErrorUaeQuarantine] = useState(false);
    const [emirateListOptions, setEmirateListOptions] = useState([]);
    const [quarantineListOptions, setQuarantineListOptions] = useState([]);
    const [errorImportPurpose, setErrorImportPurpose] = useState(false);
    const [errorEvName, setErrorEvName] = useState(false);

    const [errorHorseName, setErrorHorseName] = useState(false);
    const [errorHorseNameAr, setErrorHorseNameAr] = useState(false);
    const [errorRegNo, setErrorRegNo] = useState(false);
    const [errorSire, setErrorSire] = useState(false);
    const [errorDam, setErrorDam] = useState(false);
    const [errorMicrochipNo, setErrorMicrochipNo] = useState(false);
    const [errorDateFoaled, setErrorDateFoaled] = useState(false);
    const [errorColor, setErrorColor] = useState(false);

    const [errorOwnerName, setErrorOwnerName] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorAgentMobile, setErrorAgentMobile] = useState(false);
    const [errorPassportNo, setErrorPassportNo] = useState(false);

    const [errorShippingAgent, setErrorShippingAgent] = useState(false);

    const [errorInvitation, setErrorInvitation] = useState(false);
    const [errorHorsePassport, setErrorHorsePassport] = useState(false);
    const [errorResidencePermit, setErrorResidencePermit] = useState(false);

    const [errorLeasingContract, setErrorLeasingContract] = useState(false);
    const [errorLeaseStartDate, setErrorLeaseStartDate] = useState(false);
    const [errorLeaseEndDate, setErrorLeaseEndDate] = useState(false);
    const [errorLeasePermissions, setErrorLeasePermissions] = useState(false);
    const [errorShippingAgentNameEn, setErrorShippingAgentNameEn] = useState(false);
    const [errorShippingAgentNameAr, setErrorShippingAgentNameAr] = useState(false);
    const [errorShippingAgentMobile, setErrorShippingAgentMobile] = useState(false);
    const [errorShippingAgentEmail, setErrorShippingAgentEmail] = useState(false);

    const horseRef = useRef(null);

    //use ref
    const importDateRef = useRef(null);
    const outDateRef = useRef(null);
    const importCountryRef = useRef(null);
    const uaePlaceRef = useRef(null);
    const emirateRef = useRef(null);
    const uaeQuarantineRef = useRef(null);
    const importPurposeRef = useRef(null);
    const evNameRef = useRef(null);
    const horseNameRef = useRef(null);
    const horseNameArRef = useRef(null);
    const regNoRef = useRef(null);
    const sireRef = useRef(null);
    const damRef = useRef(null);
    const microchipNoRef = useRef(null);
    const dateFoaledRef = useRef(null);
    const colorRef = useRef(null);
    const invitationRef = useRef(null);
    const horsePassportRef = useRef(null);
    const passportNoRef = useRef(null);

    const ownerNameRef = useRef(null);
    const mobileRef = useRef(null);
    const emailRef = useRef(null);
    const agentMobileRef = useRef(null);
    const shippingAgentRef = useRef(null);
    const residencePermitRef = useRef(null);
    const leasingContractRef = useRef(null);
    const leaseStartDateRef = useRef(null);
    const leaseEndDateRef = useRef(null);
    const leasePermissionsRef = useRef(null);

    const shippingAgentNameEnRef = useRef(null);
    const shippingAgentNameArRef = useRef(null);
    const shippingAgentMobileRef = useRef(null);
    const shippingAgentEmailRef = useRef(null);

    const [errorHorse, setErrorHorse] = useState(false);

    const [
        invitationAttachmentFile,
        setInvitationAttachmentFile,
    ] = useState([]);

    const [
        horsePassportAttachmentFile,
        setHorsePassportAttachmentFile,
    ] = useState([]);

    const [
        residencePermitAttachmentFile,
        setResidencePermitAttachmentFile,
    ] = useState([]);

    const [
        leasingContractAttachmentFile,
        setLeasingContractAttachmentFile,
    ] = useState([]);


    const [isPhoneNumberAgentValid, setIsPhoneNumberAgentValid] = useState(true);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
    const [isAgentPhoneNumberValid, setIsAgentPhoneNumberValid] = useState(true);

    const _status = useRef("");
    const _isOnlinePayment = useRef("");

    // const [checkedItems, setCheckedItems] = useState({
    //     option1: false,
    //     option2: false,
    // });
    const [checkedItems, setCheckedItems] = useState({});

    const subAccountId = localStorage.getItem("currentSubAccountId");

    const customStyles = {
        control: (base) => ({
            ...base,
            height: 50,
            minHeight: 50,
        }),
    };

    //function   

    const [isPregnant, setIsPregnant] = useState(false);

    async function getEmirateList() {
        try {
            const response = await axiosInstance.get('/lookup/getmaincities');
            const formattedData = (response.data?.result || []).map((item) => ({
                label: item.name,
                value: item.id,
            }));
            setEmirateListOptions(formattedData);
            return formattedData;
        } catch (error) {
            toast.error(translate("web.errorFetchingEmirateList", "Error fetching emirate list"));
            return [];
        }
    }

    async function getQuarantinesByEmirateId(emirateId) {
        if (!emirateId) {
            setQuarantineListOptions([]);
            return [];
        }
        try {
            const response = await axiosInstance.get('/TemporaryHorseImport/GetQuarantinesByEmirateId', {
                params: { emirateId: emirateId }
            });
            const formattedData = (response.data?.result || []).map((item) => ({
                label: item.name || item.nameEn || item.nameAr,
                value: item.id,
            }));
            setQuarantineListOptions(formattedData);
            return formattedData;
        } catch (error) {
            toast.error(translate("web.errorFetchingQuarantineList", "Error fetching quarantine list"));
            return [];
        }
    }

    const handleFormChange = (e, input) => {
        // if (input === "horseImportType") {
        //     setFormModel({
        //         ...formModel,
        //         horseImportType: e.target.value,
        //     });
        // }
        if (input === "importCountry") {
            setFormModel({
                ...formModel,
                importCountry: e.value,
                importCountryDrop: e,
            });
        } else if (input === "emirateId") {
            const selectedEmirateId = e?.value || "";
            if (selectedEmirateId) {
                getQuarantinesByEmirateId(selectedEmirateId);
            } else {
                setQuarantineListOptions([]);
            }
            setFormModel({
                ...formModel,
                emirateId: selectedEmirateId,
                emirateDrop: e,
                quarantineEmirateId: selectedEmirateId,
                quarantineId: "",
                quarantineName: "",
                uaeQuarantine: "",
                uaeQuarantineDrop: {
                    label: translate("web.uaeQuarantine", "UAE Quarantine"),
                    value: null,
                },
                isLegacyQuarantine: false,
            });
            setErrorEmirate(false);
            setErrorUaeQuarantine(false);
        } else if (input === "uaeQuarantine") {
            setFormModel({
                ...formModel,
                quarantineId: e?.value || "",
                quarantineName: e?.label || "",
                uaeQuarantine: e?.value || "",
                uaeQuarantineDrop: e,
            });
            setErrorUaeQuarantine(false);
        }

        else if (input === "horseType") {
            setFormModel({
                ...formModel,
                horseType: e.target.value,

                horse: "",
                horseDrop: {
                    label: translate("web.horse", "Horse"),
                    value: null,
                },

                horseName: "",
                horseNameAr: "",
                regNo: 0,
                sire: "",
                dam: "",
                microchipNo: "",
                dateFoaled: "",
                color: "",
                colorDrop: {
                    label: translate("web.color", "Color"),
                    value: null,
                },
                sex: "Stallion",
                filePathHorsePassport: "",
                fileTypeHorsePassport: "",
                fileNameHorsePassport: "",
                fileUrlHorsePassport: "",
                horsePassportAttachmentFile: null,
            });

            setHorsePassportAttachmentFile([]);
        }
        else if (!!input && input === "horse") {
            let _horse = horsesExportTemporaryData?.find((item) => item.id == e.value);
            setFormModel({
                ...formModel,
                horse: e.value,
                horseDrop: e,
                sex: _horse?.gender || _horse?.sex || formModel.sex,
                color: _horse?.color || formModel.color,
                dateFoaled: _horse?.birthDate || formModel.dateFoaled,
            });
        }

        else if (!!input && input === "color") {
            setFormModel({
                ...formModel,
                color: e.value,
                colorDrop: e,
            });
        }
        else if (input === "registerHorse") {
            setFormModel({
                ...formModel,
                registerHorse: e.target.checked,
            });
        }
        else if (input === "otherOwner") {
            setFormModel({
                ...formModel,
                otherOwner: e.target.checked,
                ownerName: e.target.checked ? "" : profile?.label,
                email: e.target.checked ? "" : userProfile?.email,
                mobile: "",
                agentMobile: "",
                passportNo: "",
                residencePermitAttachmentFile: null
            });

            setResidencePermitAttachmentFile([]);
        }
        else if (input === "mobile") {
            setFormModel({
                ...formModel,
                mobile: e,
            });
        }
        else if (input === "agentMobile") {
            setFormModel({
                ...formModel,
                agentMobile: e,
            });
        }
        else if (input === "shippingAgent") {
            setFormModel({
                ...formModel,
                shippingAgent: e.value,
                shippingAgentDrop: e,
            });
        }
        else if (!!input && input === "horseName") {
            // const regex = /^[^\u0600-\u06FF]*$/;
            const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;

            if (regex.test(e.target.value)) {
                setFormModel({
                    ...formModel,
                    horseName: e.target.value.toUpperCase(),
                });
            }

        } else if (!!input && input === "horseNameAr") {
            // const regex = /^[^A-Za-z]*$/;

            //if (regex.test(e.target.value)) {
            setFormModel({
                ...formModel,
                horseNameAr: e.target.value.toUpperCase(),
            });
            //}
        }
        else if (input === "sire" || input === "dam") {
            setFormModel({
                ...formModel,
                [e.target.name]: e.target.value.toUpperCase(),
            });
        }
        else if (!!input && input === "microchipNo") {
            const regex = /^[0-9]*$/;

            if (regex.test(e.target.value)) {
                setFormModel({
                    ...formModel,
                    microchipNo: e.target.value,
                });
            }
        }
        else if (!!input && input === "shippingAgentNameEn") {
            const regex = /^[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]*$/;

            if (regex.test(e.target.value)) {
                setFormModel({
                    ...formModel,
                    shippingAgentNameEn: e.target.value,
                });
            }
        }
        else if (["isLeasing", "canParticipateInBeautyChampionships", "canCoverAndRegisterFoals", "canRegisterFoalsForOtherOwners", "canImportAndExport"].includes(input)) {
            setFormModel({
                ...formModel,
                [input]: e.target.checked,
                ...(input === "canCoverAndRegisterFoals" && !e.target.checked ? { canRegisterFoalsForOtherOwners: false } : {}),
            });
        }
        else if (["leaseStartDate", "leaseEndDate"].includes(input)) {
            setFormModel({
                ...formModel,
                [input]: e.target.value,
            });
        }
        else {
            const isNonMareSex = e.target.name === "sex" && e.target.value !== "Mare";
            setFormModel({
                ...formModel,
                [e.target.name]: e.target.value,
                ...(isNonMareSex ? { canRegisterFoalsForOtherOwners: false } : {}),
            });
        }
    };

    const setPhoneNumber = (value) => {
        setFormModel((prev) => ({
            ...prev,
            shippingAgentMobile: value
        }));
    }

    const handleUploadInvitationChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    invitationAttachmentFile: e.target.files[0],
                });

                setInvitationAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };

    const handleUploadHorsePassportChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    horsePassportAttachmentFile: e.target.files[0],
                });

                setHorsePassportAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };

    const handleUploadResidencePermitChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    residencePermitAttachmentFile: e.target.files[0],
                });

                setResidencePermitAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };

    const handleUploadLeasingContractChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            if (e.target.files[0].size > 10 * 1024 * 1024) {
                toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
            } else {
                setFormModel({
                    ...formModel,
                    leasingContractAttachmentFile: e.target.files[0],
                });

                setLeasingContractAttachmentFile([
                    {
                        file: e.target.files[0],
                        name: e.target.files[0].name,
                    },
                ]);
            }
        }
    };

    async function checkExistingHorse({ horseNameEn, horseNameAr, birthDate, microchipNo }) {
        try {
            const res = await axiosInstance.post('/TemporaryHorseImport/CheckHorseDuplicate', { horseNameEn, horseNameAr, birthDate, microchipNo })
            const hasError = res.data?.status?.responseCode == "100";
            return hasError;

        } catch (error) {
            console.log('error', error)
            return true;
        }
    }

    const handelAddHorse = () => {
        let valid = true;

        if (formModel.horseType === "Registered") {
            if (formModel.horse === "") {

                setErrorHorse(true);
                valid = false;

                horseRef?.current?.focus();
                return;
            }
            else {
                setErrorHorse(false);
            }
        }
        else {
            if (formModel.horseName.trim() === "") {
                setErrorHorseName(true);
                valid = false;

                horseNameRef?.current?.focus();
                return;
            }
            else {
                setErrorHorseName(false);
            }

            if (formModel.horseImportType === "PERMANENT" && formModel.horseNameAr.trim() === "") {
                setErrorHorseNameAr(true);
                valid = false;

                horseNameArRef?.current?.focus();
                return;
            }
            else {
                setErrorHorseNameAr(false);
            }

            if (formModel.horseImportType === "PERMANENT" && formModel.regNo.trim() === "") {
                setErrorRegNo(true);
                valid = false;

                regNoRef?.current?.focus();
                return;
            }
            else {
                setErrorRegNo(false);
            }

            if (formModel.microchipNo.trim() === "") {
                setErrorMicrochipNo(true);
                valid = false;

                microchipNoRef?.current?.focus();
                return;
            }
            else {
                setErrorMicrochipNo(false);
            }

            if (formModel.sire.trim() === "") {
                setErrorSire(true);
                valid = false;

                sireRef?.current?.focus();
                return;
            }
            else {
                setErrorSire(false);
            }

            if (formModel.dam.trim() === "") {
                setErrorDam(true);
                valid = false;

                damRef?.current?.focus();
                return;
            }
            else {
                setErrorDam(false);
            }

            if (formModel.dateFoaled == null) {
                setErrorDateFoaled(true);
                valid = false;

                dateFoaledRef?.current?.focus();
                return;
            }
            else {
                setErrorDateFoaled(false);
            }

            if (formModel.color === "") {
                setErrorColor(true);
                valid = false;

                colorRef?.current?.focus();
                return;
            }
            else {
                setErrorColor(false);
            }

            if (formModel.horsePassportAttachmentFile == null) {
                setErrorHorsePassport(true);
                valid = false;

                horsePassportRef?.current?.focus();
                return;
            }
            else {
                setErrorHorsePassport(false);
            }
        }


        // const hasError = await checkExistingHorse({ microchipNo: formModel.microchipNo.trim(), birthDate: formatDate(formModel.dateFoaled, false, false), horseNameAr: formModel.horseNameAr.trim(), horseNameEn: formModel.horseName.trim() })
        // if (hasError == true) {
        //     toast.error(translate('web.youAreTryingToAddRegisteredHorse', 'You Are Trying To Add a Registered Horse Please go to Registed And ad it'))
        //     return;
        // }

        if (valid) {
            let newItem = {};

            let registerHorse = horseImportType === "PERMANENT";

            if (formModel.horseType === "Registered" && registerHorse) {
                registerHorse = false;
            }

            if (formModel.horseType === "Registered") {
                let _horse = horsesExportTemporaryData.filter((item) => item.id == formModel.horse)[0];
                newItem = {
                    id: formModel?.horseNewId,
                    horseId: formModel.horse,
                    isRegisterdHorse: true,
                    horseName: _horse.nameEn,
                    horseNameAr: _horse.nameAr,
                    regNo: _horse.registerNumber,
                    microchipNo: _horse.microshipNo,
                    sire: _horse.sire,
                    dam: _horse.dam,
                    dateFoaled: dayjs(_horse.birthDate).format("DD/MM/YYYY"),
                    color: _horse.color,
                    sex: _horse.gender,
                    registerHorse: registerHorse,
                    horsePassport: formModel.horsePassportAttachmentFile,
                    horsePassportName: formModel.horsePassportAttachmentFile?.name
                };
            }
            else {
                newItem = {
                    id: formModel?.horseNewId,
                    horseId: formModel.horse,
                    isRegisterdHorse: false,
                    horseName: formModel.horseName,
                    horseNameAr: formModel.horseNameAr,
                    regNo: formModel.regNo,
                    microchipNo: formModel.microchipNo,
                    sire: formModel.sire,
                    dam: formModel.dam,
                    dateFoaled: dayjs(formModel.dateFoaled).format("DD/MM/YYYY"),
                    color: formModel.color,
                    sex: formModel.sex,
                    registerHorse: formModel.registerHorse,
                    horsePassport: formModel.horsePassportAttachmentFile,
                    horsePassportName: formModel.horsePassportAttachmentFile.name,
                    isPregnant: isPregnant
                };
            }
            return newItem;
        }
        return false;
    }

    const removeHorse = (indexToRemove) => {
        setFormModel({
            ...formModel,
            horses: formModel.horses.filter((_, index) => index !== indexToRemove)
        });
    };

    const validInputs = () => {
        let valid = true;

        if (
            formModel.horseImportType === "TEMPORARY" && formModel.evName.trim() === ""
        ) {
            setErrorEvName(true);
            valid = false;

            evNameRef?.current?.focus();
            return;
        }
        else {
            setErrorEvName(false);
        }

        if (
            formModel.horseImportType === "TEMPORARY"
            && formModel.eventType === "Racing"
            && invitationAttachmentFile.length === 0
            && formModel.fileUrlInvitation === ""
        ) {
            setErrorInvitation(true);
            valid = false;

            invitationRef?.current?.focus();
            return;
        }
        else {
            setErrorInvitation(false);
        }

        if (
            formModel.importCountry === ""
        ) {
            setErrorImportCountry(true);
            valid = false;

            importCountryRef?.current?.focus();
            return;
        }
        else {
            setErrorImportCountry(false);
        }

        if (
            formModel.importDate === null
        ) {
            setErrorImportDate(true);
            valid = false;

            importDateRef?.current?.focus();
            return;
        }
        else {
            setErrorImportDate(false);
        }

        if (
            formModel.horseImportType === "TEMPORARY" && formModel.outDate === null
        ) {
            setErrorOutDate(true);
            valid = false;

            outDateRef?.current?.focus();
            return;
        }
        else {
            setErrorOutDate(false);
        }

        if (
            dayjs(formModel.outDate).isBefore(formModel.importDate, 'day')
        ) {
            setErrorOutDate(true);
            valid = false;

            toast.error(
                translate("web.outDateEqualToLaterImportDate.", "Out date must is equal to or later than the import date.")
            );

            outDateRef?.current?.focus();

            return;
        }
        else {
            setErrorOutDate(false);
        }

        if (
            formModel.importPurpose.trim() === ""
        ) {
            setErrorImportPurpose(true);
            valid = false;

            importPurposeRef?.current?.focus();
            return;
        }
        else {
            setErrorImportPurpose(false);
        }

        if (
            formModel.horseImportType === "TEMPORARY" && formModel.uaePlace.trim() === ""
        ) {
            setErrorUaePlace(true);
            valid = false;

            uaePlaceRef?.current?.focus();
            return;
        }
        else {
            setErrorUaePlace(false);
        }

        const hasLegacyQuarantine = formModel.isLegacyQuarantine && !formModel.emirateId && !!formModel.uaeQuarantine;

        if (formModel.horseImportType === "PERMANENT") {
            if (!hasLegacyQuarantine && (!formModel.emirateId || formModel.emirateId === "")) {
                setErrorEmirate(true);
                valid = false;
                emirateRef?.current?.focus();
                return;
            } else {
                setErrorEmirate(false);
            }

            const hasQuarantine = formModel.quarantineId || formModel.uaeQuarantine;
            if (!hasQuarantine || hasQuarantine.toString().trim() === "") {
                setErrorUaeQuarantine(true);
                valid = false;
                uaeQuarantineRef?.current?.focus();
                return;
            } else {
                setErrorUaeQuarantine(false);
            }
        } else {
            setErrorEmirate(false);
            setErrorUaeQuarantine(false);
        }



        if (formModel.otherOwner) {
            if (formModel.ownerName.trim() === "") {
                setErrorOwnerName(true);
                valid = false;

                ownerNameRef?.current?.focus();
                return;
            }
            else {
                setErrorOwnerName(false);
            }

            if (formModel.email.trim() === "") {
                setErrorEmail(true);
                valid = false;

                emailRef?.current?.focus();
                return;
            }
            else {
                setErrorEmail(false);
            }

            if (formModel.mobile === "") {
                setErrorMobile(true);
                valid = false;

                mobileRef?.current?.focus();
                return;
            }
            else {
                setErrorMobile(false);
            }

            if (formModel.agentMobile === "") {
                setErrorAgentMobile(true);
                valid = false;

                agentMobileRef?.current?.focus();
                return;
            }
            else {
                setErrorAgentMobile(false);
            }

            if (
                formModel.passportNo === ""
            ) {
                setErrorPassportNo(true);
                valid = false;

                passportNoRef?.current?.focus();
                return;
            }
            else {
                setErrorPassportNo(false);
            }

            if (
                residencePermitAttachmentFile.length === 0
                && formModel.fileUrlResidencePermit === ""
            ) {
                setErrorResidencePermit(true);
                valid = false;

                residencePermitRef?.current?.focus();
                return;
            }
            else {
                setErrorResidencePermit(false);
            }
        }

        if (
            formModel.shippingAgent === ""
        ) {
            setErrorShippingAgent(true);
            valid = false;

            shippingAgentRef?.current?.focus();
            return;
        }
        else {
            setErrorShippingAgent(false);
        }

        if (
            formModel.shippingAgent === 0
        ) {

            if (
                formModel.shippingAgentNameEn === ""
            ) {
                setErrorShippingAgentNameEn(true);
                valid = false;

                shippingAgentNameEnRef?.current?.focus();
                return;
            }
            else {
                setErrorShippingAgentNameEn(false);
            }

            if (
                formModel.shippingAgentNameAr === ""
            ) {
                setErrorShippingAgentNameAr(true);
                valid = false;

                shippingAgentNameArRef?.current?.focus();
                return;
            }
            else {
                setErrorShippingAgentNameAr(false);
            }

            if (
                formModel.shippingAgentEmail === ""
            ) {
                setErrorShippingAgentEmail(true);
                valid = false;

                shippingAgentEmailRef?.current?.focus();
                return;
            }
            else {
                setErrorShippingAgentEmail(false);
            }

            if (
                formModel.shippingAgentMobile === ""
            ) {
                setErrorShippingAgentMobile(true);
                valid = false;

                shippingAgentMobileRef?.current?.focus();
                return;
            }
            else {
                setErrorShippingAgentMobile(false);
            }
        }

        //term
        if (Object.values(checkedItems).length > 0) {  // Optional safe check
            const allTermsChecked = Object.values(checkedItems).every((isChecked) => isChecked);

            if (!allTermsChecked && action == null) {
                toast.error(
                    translate("web.pleaseCheckAllTerms", "Please Check All Terms")
                );
                valid = false;
            }
        }

        if (formModel.horseImportType === "PERMANENT" && formModel.isLeasing) {
            if (!formModel.leaseStartDate) {
                setErrorLeaseStartDate(true);
                valid = false;
                leaseStartDateRef?.current?.focus();
                return;
            } else {
                setErrorLeaseStartDate(false);
            }

            if (!formModel.leaseEndDate) {
                setErrorLeaseEndDate(true);
                valid = false;
                leaseEndDateRef?.current?.focus();
                return;
            } else {
                setErrorLeaseEndDate(false);
            }

            if (leasingContractAttachmentFile.length === 0) {
                setErrorLeasingContract(true);
                valid = false;
                leasingContractRef?.current?.focus();
                return;
            } else {
                setErrorLeasingContract(false);
            }

            if (
                !formModel.canParticipateInBeautyChampionships &&
                !formModel.canCoverAndRegisterFoals &&
                !formModel.canRegisterFoalsForOtherOwners &&
                !formModel.canImportAndExport
            ) {
                setErrorLeasePermissions(true);
                valid = false;
                leasePermissionsRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return valid;
            } else {
                setErrorLeasePermissions(false);
            }
        } else {
            setErrorLeaseStartDate(false);
            setErrorLeaseEndDate(false);
            setErrorLeasingContract(false);
            setErrorLeasePermissions(false);
        }

        return valid;
    }

    const handelFormSubmit = (status, isOnlinePayment, buttonAction = 'Draft') => {
        if (getServiceDefinitionByIdData.serviceFees > 0 && formModel.paymentStatus === "Pendding" && formModel.requestsType === "BackOffice" && formModel.eventName !== "SentBack") {
            const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${id}`;

            const encodeURI = encodeURIComponent(returnUrl);

            window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${id}&paymentType=${formModel.horseImportType === "TEMPORARY" ? 21 : 22}&userId=${localStorage.getItem("EAHSUserID")}&returnUrl=${encodeURI}&isOnline=${isOnlinePayment}&lang=${currentLanguage}`;
        }
        else {
            if (
                validInputs()
            ) {
                _isOnlinePayment.current = isOnlinePayment;
                _status.current = status;
                let horsesList = handelAddHorse();
                if (horsesList == false) {
                    return;
                }

                let params = {
                    id: id == null ? '' : id,
                    ownerId: id !== null ? getServicesRequestByIdData.temporaryHorseImports.ownerId : getUserID(),
                    status: status,
                    ownerComment: formModel.ownerComment,
                    temporaryHorseImportsId: formModel.temporaryHorseImportsId,
                    horseImportType: formModel.horseImportType,
                    eventName: formModel.evName,
                    importFrom: formModel.importCountry,
                    purposeOfImport: formModel.importPurpose,
                    dateOfImport: dayjs(formModel.importDate).format("DD/MM/YYYY"),
                    endDateOfImport: formModel.outDate != null ? dayjs(formModel.outDate).format("DD/MM/YYYY") : "",
                    uAEPlaceOfDestination: formModel.uaePlace,
                    uaeQuarantine: formModel.uaeQuarantine,
                    emirateId: formModel.horseImportType === "PERMANENT" ? (formModel.emirateId || null) : null,
                    quarantineId: formModel.horseImportType === "PERMANENT" ? (formModel.quarantineId || (formModel.isLegacyQuarantine ? null : formModel.uaeQuarantine) || null) : null,
                    quarantineEmirateId: formModel.horseImportType === "PERMANENT" ? (formModel.quarantineEmirateId || formModel.emirateId || null) : null,
                    quarantineName: formModel.horseImportType === "PERMANENT" ? (formModel.quarantineName || formModel.uaeQuarantineDrop?.label || null) : null,
                    authAgentPhoneNo: formModel.agentMobile,
                    passportNo: formModel.passportNo,
                    ownerType: formModel.otherOwner ? 2 : 1,
                    shippingAgentId: formModel.shippingAgent !== 0 ? formModel.shippingAgent : '',
                    shippingAgentNameEn: formModel.shippingAgentNameEn,
                    shippingAgentNameAr: formModel.shippingAgentNameAr,
                    shippingAgentEmail: formModel.shippingAgentEmail,
                    shippingAgentMobile: formModel.shippingAgentMobile,
                    ownerFullName: formModel.ownerName,
                    ownerEmail: formModel.email,
                    ownerPhoneNo: formModel.mobile,
                    ownerPassportOrEmiratesIdCopyFile: formModel.residencePermitAttachmentFile,
                    horses: [horsesList],
                    eventType: formModel.eventType,
                    invitationCopyFile: formModel.invitationAttachmentFile,
                    buttonAction: buttonAction,
                    isLeasing: formModel.horseImportType === "PERMANENT" ? formModel.isLeasing : false,
                    leaseStartDate: formModel.leaseStartDate != null ? dayjs(formModel.leaseStartDate).format("DD/MM/YYYY") : "",
                    leaseEndDate: formModel.leaseEndDate != null ? dayjs(formModel.leaseEndDate).format("DD/MM/YYYY") : "",
                    canParticipateInBeautyChampionships: formModel.canParticipateInBeautyChampionships,
                    canCoverAndRegisterFoals: formModel.canCoverAndRegisterFoals,
                    canRegisterFoalsForOtherOwners: (
                        formModel.sex?.toLowerCase?.() === "mare" ||
                        formModel.gender?.toLowerCase?.() === "mare" ||
                        formModel.horseGender?.toLowerCase?.() === "mare"
                    ) ? formModel.canRegisterFoalsForOtherOwners : false,
                    canImportAndExport: formModel.canImportAndExport,
                    leasingContractFile: leasingContractAttachmentFile?.at(-1)?.file,
                };

                dispatch(FetchCreateOrEditHorseImportthunk(params));
            }
            else {
                toast.error(
                    translate("web.completeTheRequiredData", "Complete The Required Data")
                );
            }
        }
    };

    const handelSelectedAccountChange = async (element) => {
        setProfile(element);

        let email = "";

        const subOwnerProfiles = subOwnerProfilesByIdData;

        let subAccountEmail = subOwnerProfiles?.filter((x) => x.value == element.value)[0]?.email;

        if (subAccountEmail != undefined) {
            email = subAccountEmail;

        }
        else {
            email = userProfile.email;
        }

        setFormModel({
            ...formModel,
            ownerName: element?.label,
            email: email,
        });
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        setCheckedItems((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    function CheckIfAgentHasPermission() {
        const AgentHasPermission = userProfile.subAccounts
            .filter((x) => x.value == subAccountId)[0]
            .ownersPermissionsList.some(
                (x) =>
                    ((x.permissionName === "ImportHorseTemporary" && horseImportType === "TEMPORARY") || (x.permissionName === "ImportHorsePermanent" && horseImportType === "PERMANENT")) || x.permissionName === "All"
            );

        return AgentHasPermission;
    }

    // const getUserID = () => {
    //     const userID =
    //         !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;

    //     return userID;
    // };
    const getUserID = () => {
        let userID =
            !!userProfile && userProfile?.accountType !== "Agent" ? profile.value : subAccountId;
        if ((action == null || action === "edit") == false) {
            userID = subAccountId;
        }
        return userID;
    };

    const getSelectedAccountName = () => {
        const selectAccount = userProfile.subAccounts.filter(
            (x) => x.value == subAccountId
        );

        if (selectAccount.length > 0) {
            return selectAccount[0];
        }
        else {
            return false;
        }
    };

    const dismissAll = () => toast.dismiss();

    const handelNameLabelEventType = () => {
        if (
            formModel.eventType === "Treatment"
        ) {
            return translate("web.hospitalName", "Hospital Name");
        }
        else if (
            formModel.eventType === "Racing"
        ) {
            return translate("web.racingName", "Race Name");
        }
        else {
            return translate("web.eventName", "Event Name");
        }
    };

    const handelDisabledAddHorse = () => {
        if (
            action === "view"
            || (action === "approve" && formModel.eventName !== "SentBack")
        ) {
            return true;
        }
        else {
            if (formModel.eventName === "SentBack" && formModel.horses.length === formModel.oldHorsesListCount) {
                return true;
            }
            else {
                return false;
            }
        }
    };

    const handelDisabledButton = () => {
        if (
            action === "view"
            || (action === "approve" && formModel.eventName !== "SentBack")
        ) {
            return true;
        }
        else {
            return false;
        }
    };

    const handelDisabledInputs = () => {
        if (
            action === "view"
            || (action === "approve" && formModel.eventName === "SentBack")
        ) {
            return true;
        }
        else {
            return false;
        }
    };

    const handelDisabledOwnerInputs = () => {
        if (
            action === "view" || !formModel.otherOwner
            // || (!formModel.otherOwner && (formModel.eventName === "" || formModel.eventName === "Draft" || formModel.eventName === "SentBack"))
            // || (formModel.otherOwner && action === "approve" && formModel.eventName !== "SentBack")
        ) {
            return true;
        }
        else {
            return false;
        }
    };

    //Effect
    useEffect(() => {
        if (id != null) {
            let params = {
                language: currentLanguage,
                id: id,
                ownerId: ownerId,

            };

            dispatch(FetchGetServicesRequestByIdthunk(params));
        }

        return () => {
            dispatch(resetGetServicesRequestByIdData());
        };
    }, []);

    useEffect(() => {
        if (!!userProfile && userProfile?.haveProfileSignture != true) {
            toast.error(
                translate(
                    "web.completeOwnerProfileData",
                    "Please complete the personal data of the profile."
                )
            );

            setTimeout(() => {
                navigate("/profile");
            }, 3000);
        }

        if (!!userProfile && userProfile?.accountType === "Agent") {
            if (userProfile.id == subAccountId) {
                navigate("/403-Not-Authrized");
            }

            if (!CheckIfAgentHasPermission()) {
                navigate("/403-Not-Authrized");
            }
        }

        dispatch(FetchHorsesExportTemporarythunk());

        dispatch(FetchHorseColorsthunk({ langauge: currentLanguage }));

        let subOwnerProfilesParams = {
            id: getUserID(),
            langauge: currentLanguage,
        };
        dispatch(FetchSubOwnerProfilesByIdthunk(subOwnerProfilesParams));

        dispatch(FetchStudBookCountriesthunk(currentLanguage));

        dispatch(FetchGetShippingAgentsthunk());

        dispatch(FetchGetServiceDefinitionByIdthunk(serviceId));

        getEmirateList();
    }, [currentLanguage]);

    useEffect(() => {
        if (getServicesRequestByIdData != null &&
            Object.keys(getServicesRequestByIdData).length > 0 && (getServicesRequestByIdData.serviceDefinitionId == serviceId)
        ) {
            const firstHorse = getServicesRequestByIdData?.temporaryHorseImports?.horseTempImportDetailsDto?.[0];
            const tempImports = getServicesRequestByIdData?.temporaryHorseImports;
            const effectiveEmirateId = tempImports?.quarantineEmirateId || tempImports?.emirateId;
            const effectiveEmirateName = tempImports?.quarantineEmirateName || tempImports?.emirateName;
            const hasEmirate = !!effectiveEmirateId;
            const isLegacy = tempImports?.isLegacyQuarantine || (!hasEmirate && !!tempImports?.uaeQuarantine);
            const effectiveQuarantineId = tempImports?.quarantineId || (isLegacy ? "" : tempImports?.uaeQuarantine);
            const effectiveQuarantineName = tempImports?.quarantineName || tempImports?.uaeQuarantineName || tempImports?.uaeQuarantine;

            if (hasEmirate) {
                getQuarantinesByEmirateId(effectiveEmirateId);
            }

            setFormModel({
                ...formModel,
                eventName: getServicesRequestByIdData.eventName,
                comment: getServicesRequestByIdData.comment,
                requestsType: getServicesRequestByIdData.requestsType,
                paymentStatus: getServicesRequestByIdData.paymentStatus,
                referenceNumber: " - " + getServicesRequestByIdData.referenceNumber,

                temporaryHorseImportsId: getServicesRequestByIdData.temporaryHorseImports.id,
                horseImportType: getServicesRequestByIdData.temporaryHorseImports.horseImportType,
                importCountry: getServicesRequestByIdData.temporaryHorseImports.importFrom,
                importCountryDrop: {
                    label: getServicesRequestByIdData.temporaryHorseImports.importFromName,
                    value: getServicesRequestByIdData.temporaryHorseImports.importFrom,
                },
                importPurpose: getServicesRequestByIdData.temporaryHorseImports.purposeOfImport,
                importDate: dayjs(getServicesRequestByIdData.temporaryHorseImports.dateOfImport).format("YYYY-MM-DD"),
                outDate: getServicesRequestByIdData.temporaryHorseImports.endDateOfImport != null ? dayjs(getServicesRequestByIdData.temporaryHorseImports.endDateOfImport).format("YYYY-MM-DD") : null,
                uaePlace: getServicesRequestByIdData.temporaryHorseImports.uaePlaceOfDestination != null ? getServicesRequestByIdData.temporaryHorseImports.uaePlaceOfDestination : "",
                emirateId: effectiveEmirateId || "",
                emirateDrop: effectiveEmirateId ? {
                    label: effectiveEmirateName || translate("web.emirate", "Emirate"),
                    value: effectiveEmirateId,
                } : {
                    label: translate("web.emirate", "Emirate"),
                    value: null,
                },
                quarantineEmirateId: effectiveEmirateId || "",
                quarantineId: effectiveQuarantineId || "",
                quarantineName: effectiveQuarantineName || "",
                uaeQuarantine: tempImports?.uaeQuarantine != null ? tempImports.uaeQuarantine : "",
                uaeQuarantineDrop: effectiveQuarantineName ? {
                    label: effectiveQuarantineName,
                    value: effectiveQuarantineId || tempImports?.uaeQuarantine,
                } : {
                    label: translate("web.uaeQuarantine", "UAE Quarantine"),
                    value: null,
                },
                isLegacyQuarantine: isLegacy,
                evName: getServicesRequestByIdData.temporaryHorseImports.eventName != null ? getServicesRequestByIdData.temporaryHorseImports.eventName : "",
                eventType: getServicesRequestByIdData.temporaryHorseImports.eventType,
                agentMobile: getServicesRequestByIdData.temporaryHorseImports.authAgentPhoneNo != null ? getServicesRequestByIdData.temporaryHorseImports.authAgentPhoneNo : "",
                passportNo: getServicesRequestByIdData.temporaryHorseImports.passportNo != null ? getServicesRequestByIdData.temporaryHorseImports.passportNo : "",
                ownerComment: getServicesRequestByIdData.temporaryHorseImports.ownerComment != null ? getServicesRequestByIdData.temporaryHorseImports.ownerComment : "",
                otherOwner: getServicesRequestByIdData.temporaryHorseImports.ownerType === "CurrentOwner" ? false : true,
                shippingAgent: getServicesRequestByIdData.temporaryHorseImports.shippingAgentId,
                shippingAgentDrop: {
                    label: getServicesRequestByIdData.temporaryHorseImports.shippingAgentName,
                    value: getServicesRequestByIdData.temporaryHorseImports.shippingAgentId,
                },
                ownerName: getServicesRequestByIdData.temporaryHorseImports.ownerFullName,
                email: getServicesRequestByIdData.temporaryHorseImports.ownerEmail,
                mobile: getServicesRequestByIdData.temporaryHorseImports.ownerPhoneNo != null ? getServicesRequestByIdData.temporaryHorseImports.ownerPhoneNo : "",
                oldHorsesListCount: getServicesRequestByIdData.temporaryHorseImports.horseTempImportDetailsDto?.length,
                horses: getServicesRequestByIdData.temporaryHorseImports.horseTempImportDetailsDto.map((q) => ({
                    id: q.id,
                    horseId: q.horseId ?? "",
                    isRegisterdHorse: q.isRegisterdHorse,
                    horseName: q.horseName,
                    horseNameAr: q.horseNameAr,
                    regNo: q.registerNumber,
                    sire: q.sire,
                    dam: q.dam,
                    dateFoaled: dayjs(q.birthDateTime).format("DD/MM/YYYY"),
                    microchipNo: q.microchipNo,
                    sex: q.sex === 1 ? "Mare" : q.sex === 2 ? "Stallion" : "Gelding",
                    color: q.color,
                    isPregnant: q?.isPregnant,
                    registerHorse: q.registerPermanentHorse,
                    horsePassport: q.horsePassport?.fileUrl,
                    horsePassportType: q.horsePassport?.fileType,
                    horsePassportName: q.horsePassport?.fileName,
                })),

                filePathInvitation: getServicesRequestByIdData.temporaryHorseImports.invitation != null ? getServicesRequestByIdData.temporaryHorseImports.invitation.filePath : "",
                fileTypeInvitation: getServicesRequestByIdData.temporaryHorseImports.invitation != null ? getServicesRequestByIdData.temporaryHorseImports.invitation.fileType : "",
                fileNameInvitation: getServicesRequestByIdData.temporaryHorseImports.invitation != null ? getServicesRequestByIdData.temporaryHorseImports.invitation.fileName : "",
                fileUrlInvitation: getServicesRequestByIdData.temporaryHorseImports.invitation != null ? getServicesRequestByIdData.temporaryHorseImports.invitation.fileUrl : "",

                filePathResidencePermit: getServicesRequestByIdData.temporaryHorseImports.ownerPassport != null ? getServicesRequestByIdData.temporaryHorseImports.ownerPassport.filePath : "",
                fileTypeResidencePermit: getServicesRequestByIdData.temporaryHorseImports.ownerPassport != null ? getServicesRequestByIdData.temporaryHorseImports.ownerPassport.fileType : "",
                fileNameResidencePermit: getServicesRequestByIdData.temporaryHorseImports.ownerPassport != null ? getServicesRequestByIdData.temporaryHorseImports.ownerPassport.fileName : "",
                fileUrlResidencePermit: getServicesRequestByIdData.temporaryHorseImports.ownerPassport != null ? getServicesRequestByIdData.temporaryHorseImports.ownerPassport.fileUrl : "",

                isLeasing: getServicesRequestByIdData.temporaryHorseImports.isLeasing ?? false,
                leaseStartDate: getServicesRequestByIdData.temporaryHorseImports.leaseStartDate != null ? dayjs(getServicesRequestByIdData.temporaryHorseImports.leaseStartDate).format("YYYY-MM-DD") : null,
                leaseEndDate: getServicesRequestByIdData.temporaryHorseImports.leaseEndDate != null ? dayjs(getServicesRequestByIdData.temporaryHorseImports.leaseEndDate).format("YYYY-MM-DD") : null,
                canParticipateInBeautyChampionships: getServicesRequestByIdData.temporaryHorseImports.canParticipateInBeautyChampionships ?? false,
                canCoverAndRegisterFoals: getServicesRequestByIdData.temporaryHorseImports.canCoverAndRegisterFoals ?? false,
                canRegisterFoalsForOtherOwners: getServicesRequestByIdData.temporaryHorseImports.canRegisterFoalsForOtherOwners ?? false,
                canImportAndExport: getServicesRequestByIdData.temporaryHorseImports.canImportAndExport ?? false,

                // first horse fields merged here
                ...(!!firstHorse.isRegisterdHorse &&
                {
                    horse: firstHorse?.horseId,
                    horseDrop: {
                        label: firstHorse.registerNumber + " - " + (currentLanguage == 'en' ? firstHorse.horseName : firstHorse.horseNameAr),
                        text: firstHorse.registerNumber + " - " + (currentLanguage == 'en' ? firstHorse.horseName : firstHorse.horseNameAr),
                        value: firstHorse.horseId,
                    },
                }
                ),
                ...(firstHorse && {
                    horseNewId: firstHorse.id,
                    horseId: firstHorse.horseId ?? "",
                    isRegisterdHorse: firstHorse.isRegisterdHorse,
                    horseType: !!firstHorse.isRegisterdHorse ? "Registered" : "UnRegistered",
                    horseName: firstHorse.horseName,
                    horseNameAr: firstHorse.horseNameAr,
                    regNo: firstHorse.registerNumber,
                    sire: firstHorse.sire,
                    dam: firstHorse.dam,
                    dateFoaled: firstHorse.birthDateTime,
                    microchipNo: firstHorse.microchipNo,
                    sex: firstHorse.sex === 1 ? "Mare" : firstHorse.sex === 2 ? "Stallion" : "Gelding",
                    color: firstHorse.color,
                    isPregnant: firstHorse?.isPregnant,
                    registerHorse: firstHorse.registerPermanentHorse,
                    horsePassport: firstHorse.horsePassport?.fileUrl,
                    horsePassportType: firstHorse.horsePassport?.fileType,
                    horsePassportName: firstHorse.horsePassport?.fileName,
                    fileUrlHorsePassport: firstHorse.horsePassport?.fileUrl,
                    filePathHorsePassport: firstHorse.horsePassport?.fileUrl,
                    fileNameHorsePassport: firstHorse.horsePassport?.fileName,
                    horsePassportAttachmentFile: firstHorse.horsePassport?.fileUrl

                }),
            });
            setIsPregnant(firstHorse?.isPregnant)
            setHorsePassportAttachmentFile([{
                file: firstHorse?.horsePassport?.fileUrl,
                name: firstHorse?.horsePassport?.fileName,
            },])




            // leasing contract file
            if (getServicesRequestByIdData.temporaryHorseImports.leasingContractFile != null) {
                setLeasingContractAttachmentFile([{
                    file: getServicesRequestByIdData.temporaryHorseImports.leasingContractFile.fileUrl,
                    name: getServicesRequestByIdData.temporaryHorseImports.leasingContractFile.fileName,
                }]);
            }

            //another owner
            if (
                getServicesRequestByIdData.temporaryHorseImports.ownerId !==
                getServicesRequestByIdData.temporaryHorseImports.createdBy &&
                subOwnerProfilesByIdData.length > 0 &&
                getServicesRequestByIdData.requestsType !== "BackOffice" &&
                getServicesRequestByIdData.temporaryHorseImports.ownerType === "CurrentOwner"
            ) {
                  //update profile
                const matchedProfile = subOwnerProfilesByIdData.find(
                    (item) => item.value == getServicesRequestByIdData.temporaryHorseImports.ownerId
                );
                
                if (matchedProfile) {
                    setProfile({
                        label:
                            (matchedProfile?.registerNo ?? "") +
                            " - " +
                            (matchedProfile[`text${currentLanguage === "en" ? "" : "Ar"}`] ?? ""),
                        value: matchedProfile.value,
                    });
                }
            }
        }
    }, [
        //getServiceDefinitionByIdData,
        getServicesRequestByIdData,
    ]);

    useEffect(() => {
        if (
            toasterMessageServicesRequests != null &&
            toasterMessageServicesRequests === "save"
        ) {
            if (_isOnlinePayment.current !== "") {
                toast.success(
                    translate(
                        "web.yourRequestHasSubmittedSuccessfully",
                        "Your Request Has Submitted Successfully"
                    )
                );
            } else {
                toast.success(
                    translate("web.dataSavedSuccessfully", "Data Saved Successfully")
                );
            }

            dispatch(resetToasterMessageServicesRequests());

            setTimeout(() => {
                if (_isOnlinePayment.current !== "") {
                    const returnUrl = `${BaseURL}/profile?activeTab=${"e_services"}&serviceId=${importHorseData.id}`;

                    const encodeURI = encodeURIComponent(returnUrl);

                    window.location.href = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${importHorseData.id}&paymentType=${formModel.horseImportType === "TEMPORARY" ? 21 : 22}&userId=${localStorage.getItem(
                        "EAHSUserID"
                    )}&returnUrl=${encodeURI}&isOnline=${_isOnlinePayment.current}&lang=${currentLanguage}`;
                } else {
                    if (_status.current === "Submit" && formModel.eventName !== "SentBack") {
                        navigate(`/profile?activeTab=${"e_services"}&serviceId=${importHorseData.id}`);
                    }
                    else {
                        navigate(`/profile?activeTab=${"e_services"}`);
                    }
                }
            }, 1000);
        }

        //error
        else if (toasterMessageServicesRequests != null && toasterMessageServicesRequests !== "save") {
            if (toasterMessageServicesRequests !== "errorServiceDetails") {

                toast.error(
                    translate(toasterMessageServicesRequests, toasterMessageServicesRequests)
                );

                dispatch(resetToasterMessageServicesRequests());
            }

            else if (toasterMessageServicesRequests === "errorServiceDetails") {
                toast.error(
                    translate("web.createServiceRequestFailed", "Service Request Failed")
                );

                dispatch(resetToasterMessageServicesRequests());

                setTimeout(() => {
                    navigate(`/profile?activeTab=${"e_services"}`);
                }, 1000);
            }
        }
    }, [toasterMessageServicesRequests]);

    useEffect(() => {
        if (getServiceDefinitionByIdData?.termsList) {
            const initialState = {};
            getServiceDefinitionByIdData.termsList.forEach((_, index) => {
                initialState[`option${index + 1}`] = false;
            });
            setCheckedItems(initialState);
        }
    }, [getServiceDefinitionByIdData?.termsList]);

    //consoles
    console.log(formModel)

    return (
        <>
            {/* loading div */}
            <div
                className={`page-overlay text-center ${servicesRequestsLoading
                    ? "classdisplay"
                    : "classnotdisplay"
                    }`}
            >
                <div className="loaderDiv">
                    <Loader />
                </div>
            </div>

            {/* toast */}
            <ToastContainer
                position="top-right"
                onClick={dismissAll}
                theme="colored"
                autoClose={5000}
            />

            {/* content page */}
            <div className={serviceRequestHeadContainer}>

                {/* update Arabian Horse Data */}
                <h2 className={serviceRequestTitle}>
                    {currentLanguage === "en"
                        ? getServiceDefinitionByIdData.nameEn
                        : getServiceDefinitionByIdData.nameAr} {formModel.referenceNumber}{" "}
                </h2>


                {/* Selected Account */}
                {subOwnerProfilesByIdData.length > 0 &&
                    (action == null || action === "edit") &&
                    (
                        <div className={userDropDown}>
                            {userProfile?.accountType !== "Agent" ? (
                                <>
                                    <NetaqInput
                                        label={translate("web.selectedAccount", "Selected Account")}
                                        name="selectAccount"
                                        type="select"
                                        listSelect={[
                                            ...(!!subOwnerProfilesByIdData &&
                                                !!subOwnerProfilesByIdData.length > 0 &&
                                                subOwnerProfilesByIdData.map((a) => ({
                                                    label:
                                                        a.registerNo +
                                                        " - " +
                                                        a[`text${currentLanguage === "en" ? "" : "Ar"}`],
                                                    value: a.value,
                                                }))),
                                        ]}
                                        value={profile}
                                        onChange={(e) => {
                                            handelSelectedAccountChange(e);
                                        }}
                                        placeholder={localStorage.getItem("EAHSUserFullName")}
                                    />
                                </>
                            ) : (
                                <label className="capatalize_text">
                                    {getSelectedAccountName().registerNo +
                                        " - " +
                                        getSelectedAccountName()[
                                        `text${currentLanguage === "en" ? "" : "Ar"}`
                                        ]}
                                </label>
                            )}
                        </div>
                    )}
            </div>
            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.importDetails", "Import Details")}>
                <div className={eformInput}>
                    <NetaqInput
                        htmlTags={
                            formModel.importDate ?
                                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                    {
                                        dayjs(formModel.importDate).format("DD/MM/YYYY")
                                    }
                                </p> :
                                <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                    DD/MM/YYYY
                                </p>
                        }
                        name={"importDate"}
                        type={"normalDateService"}
                        label={translate("web.importDate", "Date Of Import")}
                        onChange={handleFormChange}
                        value={formModel.importDate}
                        required={true}
                        // maxDate={dayjs().format("YYYY-MM-DD")}
                        disabled={handelDisabledButton()}
                        ref={importDateRef}
                    />

                    {errorImportDate && (
                        <p style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </p>
                    )}
                </div>

                {formModel.horseImportType === "TEMPORARY" && (
                    <div className={eformInput}>
                        <NetaqInput
                            htmlTags={
                                formModel.outDate ?
                                    <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                        {
                                            dayjs(formModel.outDate).format("DD/MM/YYYY")
                                        }
                                    </p> :
                                    <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                        DD/MM/YYYY
                                    </p>
                            }
                            name={"outDate"}
                            type={"normalDateService"}
                            label={translate("web.outDate", "Expected date of return  after import date")}
                            onChange={handleFormChange}
                            value={formModel.outDate}
                            required={true}
                            minDate={dayjs(formModel.importDate).format("YYYY-MM-DD")}
                            //maxDate={dayjs().format("YYYY-MM-DD")}
                            disabled={handelDisabledButton()}
                            ref={outDateRef}
                        />

                        {errorOutDate && (
                            <p style={{ color: "red" }}>
                                {translate("web.requiredField", "Required Field")}
                            </p>
                        )}
                    </div>
                )}

                <div className={eformInput}>
                    <NetaqInput
                        label={translate("web.importPurpose", "Import Purpose")}
                        name={"importPurpose"}
                        type={"text"}
                        onChange={handleFormChange}
                        value={formModel.importPurpose}
                        required={true}
                        disabled={handelDisabledButton()}
                        ref={importPurposeRef}
                    />
                    {errorImportPurpose && (
                        <p style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </p>
                    )}
                </div>

                {formModel.horseImportType === "TEMPORARY" && (
                    <>
                        <div className={eformInput}>
                            <label>
                                {translate("web.eventType", "Event Type")}
                            </label>
                            <div className="row mx-0">
                                <div className={eformCheckBox}>
                                    <NetaqInput
                                        name={"eventType"}
                                        type={"radioServiceRequest"}
                                        value={"Treatment"}
                                        label={`${translate("web.treatment", "Treatment")}-`}
                                        onChange={handleFormChange}
                                        checked={formModel.eventType === "Treatment"}
                                        disabled={handelDisabledButton()}
                                    />
                                </div>
                                <div className={eformCheckBox}>
                                    <NetaqInput
                                        name={"eventType"}
                                        type={"radioServiceRequest"}
                                        value={"Racing"}
                                        label={`${translate("web.isRaceCategory", "Racing")}-`}
                                        onChange={handleFormChange}
                                        checked={
                                            formModel.eventType === "Racing"
                                        }
                                        disabled={handelDisabledButton()}
                                    />
                                </div>
                                <div className={eformCheckBox}>
                                    <NetaqInput
                                        name={"eventType"}
                                        type={"radioServiceRequest"}
                                        value={"Event"}
                                        label={`${translate("web.event", "Event")}-`}
                                        onChange={handleFormChange}
                                        checked={formModel.eventType === "Event"}
                                        disabled={handelDisabledButton()}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                label={handelNameLabelEventType()}
                                name={"evName"}
                                type={"text"}
                                onChange={handleFormChange}
                                value={formModel.evName}
                                required={true}
                                disabled={handelDisabledButton()}
                                ref={evNameRef}
                            />
                            {errorEvName && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        {(formModel.eventType === "Racing" || formModel.eventType === "Event") && (
                            <div className={eformInput}>
                                <label>
                                    {translate("web.invitationCopy", "Copy Of Invitation")}
                                    {formModel.eventType === "Racing" && (
                                        <i className="colorred"> *</i>
                                    )}
                                </label>
                                <div>
                                    <SimpleFileUpload
                                        isMulti={false}
                                        initialFiles={
                                            !!formModel.filePathInvitation &&
                                                !!formModel.fileUrlInvitation &&
                                                invitationAttachmentFile.length === 0
                                                ? [
                                                    {
                                                        file: formModel?.fileUrlInvitation,
                                                        name: formModel?.fileNameInvitation,
                                                    },
                                                ]
                                                : invitationAttachmentFile
                                        }
                                        isServer={
                                            !!formModel.filePathInvitation &&
                                                !!formModel.fileUrlInvitation &&
                                                invitationAttachmentFile.length === 0
                                                ? true
                                                : false
                                        }
                                        onChange={handleUploadInvitationChange}
                                        accept={"image/*,application/pdf"}
                                        disabled={handelDisabledButton()}
                                        ref={invitationRef}
                                    />
                                    {errorInvitation && (
                                        <span style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </span>
                                    )}
                                </div>
                            </div>
                        )}
                    </>
                )}

                <div className={eformInput}>
                    <label>
                        {translate("web.importFrom", "Import From")}
                        <i className="colorred"> *</i>
                    </label>
                    <Select
                        options={[
                            // {
                            //     label: translate("web.chooseCountry", "Choose Country"),
                            //     value: null,
                            // },
                            ...(!!studBookCountries &&
                                studBookCountries.map((a) => ({
                                    label: a.text,
                                    value: a.value,
                                }))),
                        ]}
                        value={formModel.importCountryDrop}
                        onChange={(e) => handleFormChange(e, "importCountry")}
                        placeholder={translate("web.chooseCountry", "Choose Country")}
                        name={"importCountry"}
                        isSearchable
                        noOptionsMessage={() =>
                            translate("web.noOptions", "No Options")
                        }
                        autoFocus={true}
                        key={"importCountry"}
                        isDisabled={handelDisabledButton()}
                        ref={importCountryRef}
                    />
                    {errorImportCountry && (
                        <span style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </span>
                    )}
                </div>

                {formModel.horseImportType === "TEMPORARY" && (
                    <div className={eformInput}>
                        <NetaqInput
                            label={translate("web.uaePlace", "UAE Place")}
                            name={"uaePlace"}
                            type={"text"}
                            onChange={handleFormChange}
                            value={formModel.uaePlace}
                            required={true}
                            disabled={handelDisabledButton()}
                            ref={uaePlaceRef}
                        />
                        {errorUaePlace && (
                            <p style={{ color: "red" }}>
                                {translate("web.requiredField", "Required Field")}
                            </p>
                        )}
                    </div>
                )}

                {formModel.horseImportType === "PERMANENT" && (
                    <>
                        {(!handelDisabledButton() || !!formModel.emirateId) && (
                            <div className={eformInput}>
                                <label>
                                    {translate("web.emirateQuarantine", "Emirate of Quarantine")}
                                    <i className="colorred"> *</i>
                                </label>
                                <Select
                                    options={[
                                        // {
                                        //     label: translate("web.chooseEmirate", "Choose Emirate"),
                                        //     value: null,
                                        // },
                                        ...emirateListOptions,
                                    ]}
                                    value={formModel.emirateDrop}
                                    onChange={(e) => handleFormChange(e, "emirateId")}
                                    placeholder={translate("web.chooseEmirateQuarantine", "Choose Emirate of Quarantine")}
                                    name={"emirateId"}
                                    isSearchable
                                    noOptionsMessage={() =>
                                        translate("web.noOptions", "No Options")
                                    }
                                    isDisabled={handelDisabledButton()}
                                    ref={emirateRef}
                                />
                                {errorEmirate && (
                                    <span style={{ color: "red" }}>
                                        {translate("web.requiredField", "Required Field")}
                                    </span>
                                )}
                            </div>
                        )}

                        <div className={eformInput}>
                            <label>
                                {translate("web.uaeQuarantine", "UAE Quarantine")}
                                <i className="colorred"> *</i>
                            </label>
                            <Select
                                options={[
                                    // {
                                    //     label: translate("web.chooseUaeQuarantine", "Choose UAE Quarantine"),
                                    //     value: null,
                                    // },
                                    ...(formModel.isLegacyQuarantine && !formModel.emirateId && formModel.uaeQuarantine
                                        ? [{ label: formModel.quarantineName || formModel.uaeQuarantine, value: formModel.uaeQuarantine }]
                                        : quarantineListOptions),
                                ]}
                                value={formModel.uaeQuarantineDrop}
                                onChange={(e) => handleFormChange(e, "uaeQuarantine")}
                                placeholder={translate("web.chooseUaeQuarantine", "Choose UAE Quarantine")}
                                name={"uaeQuarantine"}
                                isSearchable
                                noOptionsMessage={() =>
                                    translate("web.noOptions", "No Options")
                                }
                                isDisabled={handelDisabledButton() || (!formModel.isLegacyQuarantine && !formModel.emirateId)}
                                ref={uaeQuarantineRef}
                            />
                            {errorUaeQuarantine && (
                                <span style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div>
                    </>
                )}

            </EahsForm >

            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.horseDetails", "horse Details")}>
                <div className="row mx-0">
                    <label>
                        {translate("web.horseType", "Horse Type")}
                    </label>
                    <div className={eformCheckBox}>
                        <NetaqInput
                            name={"horseType"}
                            type={"radioServiceRequest"}
                            value={"Registered"}
                            label={`${translate("web.registeredOrReimport", "Registered")}-`}
                            onChange={(e) => handleFormChange(e, "horseType")}
                            checked={
                                formModel.horseType === "Registered"
                            }
                            disabled={handelDisabledButton()}
                        />
                    </div>

                    <div className={eformCheckBox}>
                        <NetaqInput
                            name={"horseType"}
                            type={"radioServiceRequest"}
                            value={"UnRegistered"}
                            label={`${translate("web.unregistered", "Unregistered")}-`}
                            onChange={(e) => handleFormChange(e, "horseType")}
                            checked={
                                formModel.horseType === "UnRegistered"
                            }
                            disabled={handelDisabledButton()}
                        />
                    </div>
                </div>

                {formModel.horseType === "Registered" && (
                    <>
                        <div className={eformInput}>
                            <label>
                                {translate("web.horse", "Horse")}
                                <i className="colorred"> *</i>
                            </label>
                            <Select
                                options={[
                                    {
                                        label: translate("web.horse", "Horse"),
                                        value: null,
                                    },
                                    ...(!!horsesExportTemporaryData &&
                                        horsesExportTemporaryData.map((a) => ({
                                            label: a.registerNumber + " - " + a.name,
                                            value: a.id,
                                        }))),
                                ]}
                                value={formModel.horseDrop}
                                onChange={(e) => handleFormChange(e, "horse")}
                                placeholder={translate("web.horse", "Horse")}
                                name={"horse"}
                                isSearchable
                                noOptionsMessage={() =>
                                    translate("web.noOptions", "No Options")
                                }
                                autoFocus={true}
                                key={"horse"}
                                isDisabled={handelDisabledButton()}
                                ref={horseRef}
                            />
                            {errorHorse && (
                                <span style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div>
                    </>
                )}

                {formModel.horseType === "UnRegistered" && (
                    <>
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.name", "Name") + " (EN)"}
                                name={"horseName"}
                                type={"horseName"}
                                onChange={(e) => handleFormChange(e, "horseName")}
                                value={formModel.horseName}
                                isEnOnly
                                required={true}
                                disabled={handelDisabledButton()}
                                ref={horseNameRef}
                            // maxchars={27}
                            />
                            {errorHorseName && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.name", "Name") + " (AR)"}
                                name={"horseNameAr"}
                                type={"horseName"}
                                onChange={(e) => handleFormChange(e, "horseNameAr")}
                                value={formModel.horseNameAr}
                                required={formModel.horseImportType === "PERMANENT"}
                                disabled={handelDisabledButton()}
                                // maxchars={28}
                                ref={horseNameArRef}
                            />
                            {errorHorseNameAr && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.regno", "Reg.No")}
                                name={"regNo"}
                                key={"regNo"}
                                type={"numberService"}
                                onChange={handleFormChange}
                                value={formModel.regNo}

                                minValue={0}
                                required={formModel.horseImportType === "PERMANENT"}
                                disabled={handelDisabledButton()}
                                ref={regNoRef}
                            />
                            {errorRegNo && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.microchipNo", "Microchip No")}
                                name={"microchipNo"}
                                type={"text"}
                                onChange={(e) => handleFormChange(e, "microchipNo")}
                                value={formModel.microchipNo}
                                required={true}
                                disabled={handelDisabledButton()}
                                ref={microchipNoRef}
                            />
                            {errorMicrochipNo && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.sire", "Sire")}
                                name={"sire"}
                                type={"horseName"}
                                onChange={(e) => handleFormChange(e, "sire")}
                                value={formModel.sire}
                                required={true}
                                isEnOnly
                                disabled={handelDisabledButton()}
                                ref={sireRef}
                            />
                            {errorSire && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.dam", "Dam")}
                                name={"dam"}
                                type={"horseName"}
                                onChange={(e) => handleFormChange(e, "dam")}
                                isEnOnly
                                value={formModel.dam}
                                required={true}
                                disabled={handelDisabledButton()}
                                ref={damRef}
                            />
                            {errorDam && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                htmlTags={
                                    formModel.dateFoaled ?
                                        <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                            {
                                                dayjs(formModel.dateFoaled).format("DD/MM/YYYY")
                                            }
                                        </p> :
                                        <p className="me-auto px-3 effectiveDateParagraph" style={{ textAlign: 'left' }}>
                                            DD/MM/YYYY
                                        </p>
                                }
                                name={"dateFoaled"}
                                type={"normalDateService"}
                                label={translate("web.birthDate", "birth Date")}

                                onChange={handleFormChange}
                                value={formModel.dateFoaled}
                                required={true}
                                maxDate={dayjs().format("YYYY-MM-DD")}
                                disabled={handelDisabledButton()}
                                ref={dateFoaledRef}
                            />

                            {errorDateFoaled && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <label>
                                {translate("web.color", "Color")}
                                <i className="colorred"> *</i>
                            </label>
                            <Select
                                options={[
                                    {
                                        label: translate("web.color", "Color"),
                                        value: null,
                                    },
                                    ...(!!horseColorsData &&
                                        horseColorsData.map((a) => ({
                                            label: a.nameEn,
                                            value: a.id,
                                        }))),
                                ]}
                                value={formModel.colorDrop}
                                onChange={(e) => handleFormChange(e, "color")}
                                placeholder={translate("web.color", "Color")}
                                name={"color"}
                                isSearchable
                                noOptionsMessage={() =>
                                    translate("web.noOptions", "No Options")
                                }
                                key={"color"}
                                isDisabled={handelDisabledButton()}
                                ref={colorRef}
                            />
                            {errorColor && (
                                <span style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div>

                        <div className={eformInput}>
                            <label>
                                {translate("web.sex", "Sex")}
                                <i style={{ color: "red", margin: "auto 2px" }}>*</i>
                            </label>
                            <div className="row mx-0">
                                <div className={eformCheckBox}>
                                    <NetaqInput
                                        name={"sex"}
                                        type={"radioServiceRequest"}
                                        value={"Stallion"}
                                        label={`${translate("web.stallion", "Stallion")}-`}
                                        onChange={handleFormChange}
                                        checked={formModel.sex === "Stallion"}
                                        disabled={handelDisabledButton()}
                                    />
                                </div>
                                <div className={eformCheckBox}>
                                    <NetaqInput
                                        name={"sex"}
                                        type={"radioServiceRequest"}
                                        value={"Mare"}
                                        label={`${translate("web.mare", "Mare")}`}
                                        onChange={handleFormChange}
                                        checked={
                                            formModel.sex === "Mare"
                                        }
                                        disabled={handelDisabledButton()}
                                    />
                                    {formModel.sex == 'Mare' && <>
                                        <div className="mt-2">
                                            <NetaqInput
                                                name={"IsPregnant"}
                                                type={"checkbox"}
                                                label={`${translate("web.isPregnant", "Stallion")}`}
                                                onChange={(e) => {
                                                    setIsPregnant(e.target.checked)
                                                }}
                                                checked={isPregnant}
                                                disabled={handelDisabledButton()}
                                            />
                                        </div>
                                    </>}
                                </div>
                                <div className={eformCheckBox}>
                                    <NetaqInput
                                        name={"sex"}
                                        type={"radioServiceRequest"}
                                        value={"Gelding"}
                                        label={`${translate("web.gelding", "Gelding")}-`}
                                        onChange={handleFormChange}
                                        checked={formModel.sex === "Gelding"}
                                        disabled={handelDisabledButton()}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div className={eformInput}>
                    <label>
                        {translate("web.horsePassport", "Horse Passport")}
                        {formModel.horseType === "UnRegistered" && (
                            <i className="colorred"> *</i>
                        )}
                    </label>
                    <SimpleFileUpload
                        key={`horsePassportIndex-1-${formModel.horses?.length} `}
                        isMulti={false}
                        initialFiles={
                            !!formModel.filePathHorsePassport &&
                                !!formModel.fileUrlHorsePassport &&
                                horsePassportAttachmentFile.length === 0
                                ? [
                                    {
                                        file: formModel?.fileUrlHorsePassport,
                                        name: formModel?.fileNameHorsePassport,
                                    },
                                ]
                                : horsePassportAttachmentFile
                        }
                        isServer={
                            formModel?.fileUrlHorsePassport?.startsWith('http')
                        }
                        onChange={handleUploadHorsePassportChange}
                        accept={"image/*,application/pdf"}
                        disabled={handelDisabledButton()}
                        ref={horsePassportRef}
                    />
                    {errorHorsePassport && (
                        <span style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </span>
                    )}
                </div>

                {/* <div className="col-sm-2 col-6 mb-2 ms-auto">
                    <NewActionButton
                        classNames="btn-dark"
                        text={
                            <>
                                <i class="fa-solid fa-circle-plus"></i>
                                {translate("web.addToList", "Add To List")}
                            </>}
                        onClick={handelAddHorse}
                        disabled={handelDisabledAddHorse()}
                    />
                </div> */}
                {formModel.horses?.length > 1 &&

                    <div className="scrolableTable">
                        <table className="table table-striped table-bordered rtl horseResultTable">
                            <thead className="theadHorseSelect">
                                <tr>
                                    <th className="text-center">
                                        {translate("web.name", "Name") + " (En)"}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.name", "Name") + " (AR)"}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.regno", "Reg.No")}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.sire", "Sire")}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.dam", "Dam")}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.microchipNo", "Microchip No")}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.dateFoaled", "Date Foaled")}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.color", "Color")}
                                    </th>
                                    <th className="text-center">
                                        {translate("web.sex", "Sex")}
                                    </th>
                                    {/* {formModel.horseImportType === "PERMANENT" && (
                                    <th className="text-center" style={{display:"none"}}>
                                        {translate("web.registerType", "Register Type")}
                                    </th>
                                )} */}
                                    <th className="text-center">
                                        {translate("web.horsePassport", "Horse Passport")}
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                {formModel.horses?.length > 0 && (
                                    formModel.horses.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.horseName}</td>
                                            <td>{item.horseNameAr}</td>
                                            <td>{item.regNo}</td>
                                            <td>{item.sire}</td>
                                            <td>{item.dam}</td>
                                            <td>{item.microchipNo == "null" ? "" : item.microchipNo}</td>
                                            <td>{item.dateFoaled}</td>
                                            <td> {horseColorsData.filter(q => q.id == item.color)[0].nameEn}</td>
                                            <td> {`${translate(`web.${item.sex.toLowerCase()}`, item.sex)}`} {item?.isPregnant == true ? `(${translate('web.pregnant', 'Pregnant')})` : ''} </td>
                                            {/* {formModel.horseImportType === "PERMANENT" && (
                                            <td style={{display:"none"}}>{item.registerHorse ? translate("web.registere", "Registere") : translate("web.UnRegistere", "UnRegistere")}</td>
                                        )} */}
                                            <td>
                                                {item?.horsePassport != null && (
                                                    <SimpleFileUpload
                                                        isMulti={false}
                                                        isJustView
                                                        initialFiles={
                                                            !!item.id && item.horsePassport != null
                                                                ? [
                                                                    {
                                                                        file: item.horsePassport,
                                                                        name: item.horsePassportName,
                                                                    },
                                                                ]
                                                                : [{ file: item.horsePassport, name: item.horsePassportName }]
                                                        }
                                                        isServer={
                                                            !!item.id
                                                                ? true
                                                                : false
                                                        }
                                                        // onChange={handleUploadHorsePassportChange}
                                                        accept={"image/*,application/pdf"}
                                                        disabled={true}
                                                    />
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </EahsForm>

            {/* {formModel.horseImportType === "PERMANENT" && (
                <HorseLeasingSection
                    formModel={formModel}
                    handleFormChange={handleFormChange}
                    handelDisabledButton={handelDisabledButton}
                    leasingContractAttachmentFile={leasingContractAttachmentFile}
                    handleUploadLeasingContractChange={handleUploadLeasingContractChange}
                    leasingContractRef={leasingContractRef}
                    errorLeasingContract={errorLeasingContract}
                    errorLeaseStartDate={errorLeaseStartDate}
                    errorLeaseEndDate={errorLeaseEndDate}
                    leaseStartDateRef={leaseStartDateRef}
                    leaseEndDateRef={leaseEndDateRef}
                    leasePermissionsRef={leasePermissionsRef}
                    errorLeasePermissions={errorLeasePermissions}
                />
            )} */}

            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.ImportOrReimportTo", "Owner Details")}>
                <div className="row">
                    <div className={eformCheckBox}>
                        <NetaqInput
                            type={"checkbox"}
                            label={translate(
                                "web.importForOtherOwner",
                                "Import For Other Owner"
                            )}
                            name="otherOwner"
                            checked={formModel.otherOwner}
                            onChange={(e) => handleFormChange(e, "otherOwner")}
                            disabled={action === "view"}
                        />
                    </div>
                </div>

                <div className={eformInput}>
                    <NetaqInput
                        label={translate("web.ownerName", "Owner Name")}
                        name={"ownerName"}
                        isSupportAllCharacters={true}
                        type={"horseName"}
                        onChange={handleFormChange}
                        value={formModel.ownerName}
                        required={formModel.otherOwner}
                        disabled={handelDisabledOwnerInputs()}
                        ref={ownerNameRef}
                    />
                    {errorOwnerName && (
                        <p style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </p>
                    )}
                </div>

                <div className={eformInput}>
                    <NetaqInput
                        label={translate("web.email", "Email")}
                        name={"email"}
                        type={"text"}
                        onChange={handleFormChange}
                        value={formModel.email}
                        required={formModel.otherOwner}
                        disabled={handelDisabledOwnerInputs()}
                        ref={emailRef}
                    />
                    {errorEmail && (
                        <p style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </p>
                    )}
                </div>

                {formModel.otherOwner && (
                    <>
                        <div className={eformInput}>
                            <NetaqInput
                                type={'phone'}
                                value={formModel.mobile}
                                label={translate("web.smsPhoneNo", "Mobile No")}
                                name={'mobile'}
                                placeholder={'971xxxxxxxxx'}
                                required={true}
                                onChange={(e) => handleFormChange(e, "mobile")}
                                //onChange={setPhoneNumber}
                                setIsPhoneNumberValid={setIsPhoneNumberValid}
                                disabled={handelDisabledButton()}
                                ref={mobileRef}
                            />
                            {!isPhoneNumberValid &&
                                <div className='text-danger'>
                                    {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                </div>
                            }
                            {errorMobile && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                type={'phone'}
                                value={formModel.agentMobile}
                                label={translate("web.agentMobile", "Agent Mobile")}
                                name={'agentMobile'}
                                placeholder={'971xxxxxxxxx'}
                                required={true}
                                onChange={(e) => handleFormChange(e, "agentMobile")}
                                setIsPhoneNumberValid={setIsAgentPhoneNumberValid}
                                disabled={handelDisabledButton()}
                                ref={agentMobileRef}
                            />
                            {!isAgentPhoneNumberValid &&
                                <div className='text-danger'>
                                    {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                </div>
                            }
                            {errorAgentMobile && (
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            )}
                        </div>

                        <div className={eformInput}>
                            <NetaqInput
                                // label={translate("web.passport", "Passport")}
                                label={translate("web.passport", "Passport")}
                                name={"passportNo"}
                                type={"text"}
                                disabled={handelDisabledButton()}
                                value={formModel.passportNo}
                                onChange={handleFormChange}
                                isDash={true}
                                required={true}
                                ref={passportNoRef}
                            />
                            {errorPassportNo && (
                                <span style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div>

                        <div className={eformInput}>
                            <label>
                                {/* {translate("web.residencePermit", "Residence Permit")} */}
                                {translate("web.ownerPassportCopy", "Owner Passport Copy")}
                                <i className="colorred"> *</i>
                            </label>
                            <div>
                                <SimpleFileUpload
                                    isMulti={false}
                                    initialFiles={
                                        !!formModel.filePathResidencePermit &&
                                            !!formModel.fileUrlResidencePermit &&
                                            residencePermitAttachmentFile.length === 0
                                            ? [
                                                {
                                                    file: formModel?.fileUrlResidencePermit,
                                                    name: formModel?.fileNameResidencePermit,
                                                },
                                            ]
                                            : residencePermitAttachmentFile
                                    }
                                    isServer={
                                        !!formModel.filePathResidencePermit &&
                                            !!formModel.fileUrlResidencePermit &&
                                            residencePermitAttachmentFile.length === 0
                                            ? true
                                            : false
                                    }
                                    onChange={handleUploadResidencePermitChange}
                                    accept={"image/*,application/pdf"}
                                    disabled={handelDisabledButton()}
                                    ref={residencePermitRef}
                                />
                                {
                                    errorResidencePermit && (
                                        <span style={{ color: "red" }}>
                                            {translate("web.requiredField", "Required Field")}
                                        </span>
                                    )}
                            </div>
                        </div>
                    </>
                )}
            </EahsForm>

            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.shippingAgent", "Shipping Agent")}>
                <div className={eformInput}>
                    <label>
                        {translate("web.shippingAgent", "Shipping Agent")}
                        <i className="colorred"> *</i>
                    </label>
                    <Select
                        options={[
                            {
                                label: translate("web.shippingAgent", "Shipping Agent"),
                                value: null,
                            },
                            ...(!!getShippingAgentsData &&
                                getShippingAgentsData.map((a) => ({
                                    label: a.text,
                                    value: a.value,
                                }))),
                            {
                                label: translate("web.other", "Other"),
                                value: 0,
                            }
                        ]}
                        value={formModel.shippingAgentDrop}
                        onChange={(e) => handleFormChange(e, "shippingAgent")}
                        placeholder={translate("web.shippingAgent", "Shipping Agent")}
                        name={"shippingAgent"}
                        isSearchable
                        noOptionsMessage={() =>
                            translate("web.noOptions", "No Options")
                        }
                        autoFocus={true}
                        key={"shippingAgent"}
                        isDisabled={handelDisabledButton()}
                        ref={shippingAgentRef}
                    />
                    {errorShippingAgent && (
                        <span style={{ color: "red" }}>
                            {translate("web.requiredField", "Required Field")}
                        </span>
                    )}
                </div>

                {formModel.shippingAgent === 0 &&
                    <>
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.name", "Name") + " (EN)"}
                                name={"shippingAgentNameEn"}
                                type={"text"}
                                onChange={(e) => handleFormChange(e, "shippingAgentNameEn")}
                                value={formModel.shippingAgentNameEn}
                                required={true}
                                ref={shippingAgentNameEnRef}
                            />
                            {errorShippingAgentNameEn &&
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            }
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.name", "Name") + " (AR)"}
                                name={"shippingAgentNameAr"}
                                type={"text"}
                                onChange={handleFormChange}
                                value={formModel.shippingAgentNameAr}
                                required={true}
                                ref={shippingAgentNameArRef}
                            />
                            {errorShippingAgentNameAr &&
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            }
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.email", "Email")}
                                name={"shippingAgentEmail"}
                                type={"text"}
                                onChange={handleFormChange}
                                value={formModel.shippingAgentEmail}
                                required={true}
                                ref={shippingAgentEmailRef}
                            />
                            {errorShippingAgentEmail &&
                                <p style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </p>
                            }
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                type={'phone'}
                                value={formModel.shippingAgentMobile}
                                label={translate("web.smsPhoneNo", "Mobile No")}
                                name={'shippingAgentMobile'}
                                placeholder={'971xxxxxxxxx'}
                                required={true}
                                onChange={setPhoneNumber}
                                setIsPhoneNumberValid={setIsPhoneNumberAgentValid}
                                ref={shippingAgentEmailRef}
                            />
                            {!isPhoneNumberAgentValid &&
                                <div className='text-danger'>
                                    {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                </div>
                            }
                            {errorShippingAgentMobile && (
                                <span
                                    style={{ color: "red" }}>
                                    {translate("web.requiredField", "Required Field")}
                                </span>
                            )}
                        </div>
                    </>
                }
            </EahsForm>

            {/* Comments */}
            {(!!formModel.comment || !!formModel.ownerComment) && (
                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.comments", "Comments")}>
                    {!!formModel.comment && (
                        // eahs Comment
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.eahsComments", "EAHS Comments")}
                                name={"adminComment"}
                                type={"textarea"}
                                maxchars={1150}
                                value={formModel.comment}
                                disabled={true}
                            />
                        </div>
                    )}

                    {(!!formModel.ownerComment || (formModel.eventName === "SentBack" && action !== "view")) && (
                        // owner Comment
                        <div className={eformInput}>
                            <NetaqInput
                                label={translate("web.ownerComment", "Owner Comment")}
                                name={"ownerComment"}
                                type={"textarea"}
                                maxchars={1150}
                                value={formModel.ownerComment}
                                onChange={handleFormChange}
                                disabled={formModel.eventName !== "SentBack" ? true : false}
                            />
                        </div>
                    )}
                </EahsForm>
            )}

            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate("web.terms", "Terms")}>
                {getServiceDefinitionByIdData?.termsList?.map((item, index) => {
                    return (
                        <div className={eformTerms} key={index}>
                            <NetaqInput
                                type={"checkbox"}
                                label={item}
                                name={`option${index + 1}`}
                                checked={checkedItems[`option${index + 1}`] || action != null}
                                onChange={handleCheckboxChange}
                                disabled={formModel.eventName !== ""}
                            />
                        </div>
                    );
                })}
            </EahsForm>

            <div className={eFormButtonsContainer}>
                {(formModel.eventName === "" || formModel.eventName === "Draft") && (
                    <DraftBtn
                        key={translate("web.draft", "Draft")}
                        onClick={() => handelFormSubmit("Draft", "", 'Draft')}
                        disabled={
                            formModel.eventName === "" ||
                                formModel.eventName === "Draft"
                                ? false
                                : true
                        }
                    />
                )}
                {userProfile?.participateWithoutPayment === true && formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                    <ApproveAndPayLaterBtn
                        selectedAccountId={profile?.value}

                        isApprove={false}
                        key={`${translate("web.payLater", "Pay Later")}`}
                        onClick={() =>
                            handelFormSubmit("Draft", "no", 'Pay')
                        }
                        disabled={
                            formModel.eventName === "SentBack"
                                ? true
                                : false
                        }
                    />
                )}
                {formModel.eventName !== "SentBack" && action !== "view" && getServiceDefinitionByIdData.serviceFees > 0 && (
                    <ApproveAndPayBtn
                        selectedAccountId={profile?.value}
                        key={translate("web.approvePay", "Approve And Pay")}
                        onClick={() =>
                            handelFormSubmit("Draft", "yes", 'Pay')
                        }
                        disabled={
                            formModel.eventName === "SentBack"
                                ? true
                                : false
                        }
                    />
                )}
                {((getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack") && action !== "view") && (
                    <SubmitServiceBtn
                        key={translate("web.submit", "Submit")}
                        onClick={() =>
                            handelFormSubmit("Submit", "", 'Submit')
                        }
                        disabled={
                            getServiceDefinitionByIdData.serviceFees === 0 || formModel.eventName === "SentBack"
                                ? false
                                : true
                        }
                    />
                )}
            </div>
        </>
    );
}
